import {Flex, Img, Link, Stack} from '@chakra-ui/react';
import {GeoLink} from 'components/action/GeoLink';
import {RouteNames} from 'modules/navigation';
import {useLocalizedNavigation} from 'modules/navigation/hooks';
import NextLink from 'next/link';
import {useRouter} from 'next/router';
import React from 'react';
import {statusIconNav} from './hooks';

export interface GeoIconExtendProps {
	link?: RouteNames;
	src?: string;
	label?: string;
}

export const GeoIconExtend: React.FC<GeoIconExtendProps> = ({
	link,
	src,
	label
}: GeoIconExtendProps) => {
	const [status, setStatus] = React.useState<statusIconNav>('inactive');
	const router = useRouter();
	const isCurrentPath = router.pathname.includes(link);
	const {getPath} = useLocalizedNavigation();
	const renderStatus = () => {
		switch (status) {
			case 'hover':
				return `/images/${src}-hover.svg`;
			default:
				return `/images/${src}.svg`;
		}
	};
	const renderText = () => {
		switch (status) {
			case 'hover':
				return 'bold';
			default:
				return 'medium';
		}
	};
	const renderTextColor = () => {
		switch (status) {
			case 'hover':
				return 'black';
			default:
				return 'geoGrey.500';
		}
	};
	return (
		<Stack direction='row'>
			<NextLink passHref href={getPath(link, false)}>
				<Link sx={{_focus: {outline: 0}}} width='max-content'>
					<Img
						src={isCurrentPath ? `/images/${src}-active.svg` : renderStatus()}
						height='3.1em'
						maxHeight='55px'
						width='3em'
						maxWidth='100px'
						onMouseEnter={() => setStatus('hover')}
						onMouseOut={() => setStatus('inactive')}
					/>
				</Link>
			</NextLink>
			<Flex alignItems='center'>
				<GeoLink
					variant='Link'
					color={isCurrentPath ? 'geoBlue.500' : renderTextColor()}
					label={label}
					to={link}
					fontSize='sm'
					fontWeight={isCurrentPath ? 'bold' : renderText()}
					onMouseEnter={() => setStatus('hover')}
					onMouseOut={() => setStatus('inactive')}
				/>
			</Flex>
		</Stack>
	);
};
